/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gallery_Hub_TitleInputs */

const en_us2_gallery_hub_title = /** @type {(inputs: Gallery_Hub_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plan gallery`)
};

const pt_br2_gallery_hub_title = /** @type {(inputs: Gallery_Hub_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Galeria de planos`)
};

const pt_pt2_gallery_hub_title = /** @type {(inputs: Gallery_Hub_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Galeria de planos`)
};

/** @type {(inputs: Gallery_Hub_TitleInputs) => LocalizedString} */
const es_419_gallery_hub_title = en_us2_gallery_hub_title;

/** @type {(inputs: Gallery_Hub_TitleInputs) => LocalizedString} */
const fr_fr2_gallery_hub_title = en_us2_gallery_hub_title;

/** @type {(inputs: Gallery_Hub_TitleInputs) => LocalizedString} */
const de_de2_gallery_hub_title = en_us2_gallery_hub_title;

/** @type {(inputs: Gallery_Hub_TitleInputs) => LocalizedString} */
const it_it2_gallery_hub_title = en_us2_gallery_hub_title;

/**
* | output |
* | --- |
* | "Plan gallery" |
*
* @param {Gallery_Hub_TitleInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const gallery_hub_title = /** @type {((inputs?: Gallery_Hub_TitleInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gallery_Hub_TitleInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_gallery_hub_title(inputs)
	if (locale === "es-419") return es_419_gallery_hub_title(inputs)
	if (locale === "pt-PT") return pt_pt2_gallery_hub_title(inputs)
	if (locale === "fr-FR") return fr_fr2_gallery_hub_title(inputs)
	if (locale === "de-DE") return de_de2_gallery_hub_title(inputs)
	if (locale === "it-IT") return it_it2_gallery_hub_title(inputs)
	return en_us2_gallery_hub_title(inputs)
});
export { gallery_hub_title as "gallery.hub_title" }